<p-select
  class="cx-select__select"
  [styleClass]="styleClass"
  [pt]="pt"
  [inputId]="inputId"
  [options]="selectOptions"
  [optionLabel]="optionLabel"
  [optionValue]="optionValue"
  [optionDisabled]="optionDisabled"
  panelStyleClass="cx-select-panel"
  [appendTo]="appendTo"
  [placeholder]="placeholder"
  [disabled]="isDisabled"
  [loading]="loading"
  [filter]="filter"
  [showClear]="showClear"
  [invalid]="isInvalid"
  [fluid]="true"
  [dataKey]="optionValue"
  [ngModel]="singleValue"
  [ngModelOptions]="{ standalone: true }"
  (ngModelChange)="onSelectionChange($event)"
  (onBlur)="onBlur()">
  @if (itemTemplate) {
    <ng-template #item let-option>
      <ng-container [ngTemplateOutlet]="itemTemplate" [ngTemplateOutletContext]="{ $implicit: option }"></ng-container>
    </ng-template>
  }
  @if (selectedItemTemplate) {
    <ng-template #selectedItem let-option>
      <ng-container [ngTemplateOutlet]="selectedItemTemplate" [ngTemplateOutletContext]="{ $implicit: option }"></ng-container>
    </ng-template>
  }
</p-select>
